import { render, staticRenderFns } from "./commission-plan.vue?vue&type=template&id=cea21e56&scoped=true"
import script from "./commission-plan.vue?vue&type=script&lang=js"
export * from "./commission-plan.vue?vue&type=script&lang=js"
import style0 from "./commission-plan.vue?vue&type=style&index=0&id=cea21e56&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cea21e56",
  null
  
)

export default component.exports